module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "best-rating"
  }, [_c('vm-tabs', {
    attrs: {
      "title": "最佳评价",
      "navPosition": "right",
      "navItemPadding": "15",
      "showMoreIcon": true
    }
  }, _vm._l((_vm.data), function(type, i) {
    return _c('vm-tab-pane', {
      key: type.name,
      attrs: {
        "label": type.name
      }
    }, [_c('vm-collapse', {
      attrs: {
        "accordion": "",
        "transform": "",
        "remain": 1
      },
      model: {
        value: (_vm.actionNames[i]),
        callback: function($$v) {
          _vm.$set(_vm.actionNames, i, $$v)
        },
        expression: "actionNames[i]"
      }
    }, _vm._l((type.data), function(item, index) {
      return _c('vm-collapse-item', {
        key: item.rank,
        attrs: {
          "name": item.rank
        }
      }, [_c('template', {
        slot: "header"
      }, [_c('span', {
        staticClass: "best-rating__rank"
      }, [_vm._v(_vm._s(item.rank))]), _vm._v(" "), _c('span', {
        staticClass: "best-rating__name"
      }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
        staticClass: "best-rating__type"
      }, [_vm._v(_vm._s(item.type))])]), _vm._v(" "), _c('div', {
        staticClass: "best-rating__content"
      }, [_c('span', {
        staticClass: "best-rating__rank"
      }, [_vm._v(_vm._s(item.rank))]), _vm._v(" "), _c('img', {
        attrs: {
          "src": item.image,
          "alt": item.name
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "best-rating__content-right"
      }, [_c('span', {
        staticClass: "best-rating__content__name"
      }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('vm-rate', {
        attrs: {
          "size": 14,
          "colors": ['#31D29B', '#31D29B', '#31D29B'],
          "disabled-void-icon-class": "vm-icon-star-empty",
          "disabled-void-color": "#31D29B",
          "disabled": ""
        },
        model: {
          value: (item.rate),
          callback: function($$v) {
            item.rate = $$v
          },
          expression: "item.rate"
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "best-rating__content__type"
      }, [_vm._v(_vm._s(item.type))])], 1), _vm._v(" "), _c('button', {
        staticClass: "best-rating__download"
      }, [_vm._v("立即下载")])])], 2)
    }))], 1)
  }))], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-48c64482", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48c64482","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./example/src/best-rating.vue
// module id = 25
// module chunks = 0